/**
 * Detects non-actionable errors that originate entirely from browser
 * extensions. These are errors where every stack frame points at a
 * `chrome-extension://`, `moz-extension://`, or `safari-web-extension://`
 * URL, meaning no application code is involved.
 *
 * Example: a Chrome extension running `querySelector` with an invalid CSS
 * selector produces a `SyntaxError` whose stack is entirely within the
 * extension bundle. The Datadog RUM SDK captures this as an unhandled
 * error, but it is not actionable from application code.
 */

const EXTENSION_SCHEMES = [
  "chrome-extension://",
  "moz-extension://",
  "safari-web-extension://",
];

export function isBrowserExtensionStackNoise(
  message: string | undefined,
  stack: string | undefined,
): boolean {
  if (!message || !stack) {
    return false;
  }

  const frames = stack
    .split("\n")
    .filter((line) => line.trim().startsWith("at "));

  if (frames.length === 0) {
    return false;
  }

  return frames.every((frame) =>
    EXTENSION_SCHEMES.some((scheme) => frame.includes(scheme)),
  );
}
